import { gql } from '@apollo/client'

export default gql(`
    query listCountry($search: SearchInput $limit: Int $offset: Int $project: String){
        listCountry( 
            search: $search
            limit: $limit
            offset: $offset
            project: $project
        ) {
        items {
            id
            name
            source
            assetCount
        }
        totalCount
    }
}`)
